import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: 'app-versatile-list-footer',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./versatile-list-footer.component.scss']
})
export class VersatileListFooterComponent {
    @HostBinding('class.footer') hostClass = true;
    @Input() isLoading = false;

    @HostBinding('class.loading')
    get loadingClass(): boolean {
        return this.isLoading;
    }
}
